package music.jammers.shared.track.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class Track(
    val id: Long,
    val name: String,
    val artist: Artist,
)